import React from 'react';
import Spinner from '../Spinner';
import './Button.css';
const Button = (props) => {
    return (React.createElement("div", { className: ` ${props.className ?? ''}`, style: { ...props.style } },
        React.createElement("button", { id: props.id ?? undefined, type: props.submit ? 'submit' : 'button', className: `${props.block ? 'w-full' : 'w-auto'} h-auto min-w-[120px] m-0 button button-${props.size ?? 'md'} button-${props.type ?? 'secondary'}`, onClick: props.onClick, title: props.title, disabled: props.disabled ?? false },
            React.createElement("div", { className: "flex flex-row", style: { justifyContent: 'center', alignItems: 'center' } },
                props.loading && (React.createElement("div", { className: "mr-5" },
                    React.createElement(Spinner, { onSurface: true, size: "sm" }))),
                props.icon && (!props.iconPosition || props.iconPosition === 'left') ? (React.createElement("div", { style: { marginRight: '5px' } }, props.icon)) : null,
                props.title,
                props.icon && props.iconPosition == 'right' ? React.createElement("div", { style: { marginRight: '5px' } }, props.icon) : null))));
};
export default Button;
